
import { mapState, mapActions } from 'vuex'
import breadcrumbMixins from '@/mixins/breadcrumb'
import DetailWishlistMixin from '@/mixins/DetailWish'
import ProductGallery from '@/components/product/detail/ProductGallery'
import ProductInfo from '@/components/product/detail/ProductInfo'
import ProductCart from '@/components/product/detail/ProductCart'
import ProductComments from '@/components/product/detail/ProductComments'
import ProductSlide from '@/components/product/swiper/recommend'

export default {
  layout: 'detail',

  components: {
    ProductGallery,
    ProductInfo,
    ProductCart,
    ProductComments,
    ProductSlide,
  },

  mixins: [breadcrumbMixins, DetailWishlistMixin],

  async fetch({ store, params }) {
    const input = {
      id: params.show,
    }

    // get product
    await store.dispatch('product/detail/getProduct', input)

    // check product has exists then fetch recommend product
    if (store.state.product.detail.product) {
      // get recommended products
      await store.dispatch('product_recommend/detail/getProductRecommend', {
        id: params.show,
        category_id: store.state.product.detail.product.categories.map((item) => item.category_id),
      })
    }
  },

  computed: {
    ...mapState('product/detail', ['product', 'error_message']),
    ...mapState('product_recommend/detail', ['product_recommends']),
  },

  methods: {
    ...mapActions({
      getWishlist: 'product/wishlist/getWishlist',
      resetWishlist: 'product/wishlist/resetWishlist',
    }),

    initWishlist() {
      if (this.$auth.loggedIn) {
        this.getWishlist()
      } else {
        this.resetWishlist()
      }
    },

    /**
     * @description: convert html to text
     */
    convertSEOContent(string) {
      return string.replace(/<[^>]*>?/gm, '').substr(0, 160)
    },
  },

  head() {
    return {
      title: this.product.name + ' - JaFun',
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: this.convertSEOContent(this.product.content),
        },
        {
          hid: 'og:description',
          property: 'og:description',
          content: this.convertSEOContent(this.product.content),
        },
        { hid: 'og:image', property: 'og:image', content: this.product.product_photos[0]?.url },
      ],
    }
  },
}
